"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var shared_1 = require("@formily/shared");
var env = {
    portalDOM: null
};
exports.render = function (element) {
    if (shared_1.globalThisPolyfill['document']) {
        env.portalDOM =
            env.portalDOM || shared_1.globalThisPolyfill['document'].createElement('div');
        return require('react-dom').createPortal(element, env.portalDOM);
    }
    else {
        return react_1.default.createElement("template", null, element);
    }
};
